<template>
<div class="resource">
    <h1 class="subheading grey--text"></h1>
    <v-container class="my-5">
        <v-layout>
            <v-flex>
                <div>
                    <h3>Foldregler</h3>
                    <p>Der kan bookes tid på dagen og til efterfølgende dag.
                        Der må kun bookes en foldtid pr hest. Hvis foldtid ikke anvendes slettes bookning så andre har mulighed for at bruge tiden. Hvis foldtiden kun benyttes i en del af tiden slettes bookning når hest tages ind, så andre har mulighed for at benytte tiden. Hvis folden ikke er benyttes ½ time inde i den bookede tid, må tiden benyttes af andre.

                    </p>
                    <h3>Weekend og helligdage:</h3>
                    <p>Fold 1-12 må bookes i tre timer i intervallet 9-12 og 12-15. Før kl 9.00 og efter kl 15 må folden bookes i kortere tid.

                    </p>
                    <h3>Hverdage:</h3>

                    Fold 1-8 og 11-12 må ikke anvendes, idet disse er reserveret til foldordningen.
                    Fold 9-10 må bookes i to timer.

                </div>

            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {

}
</script>
